export default __webpack_public_path__ + "static/media/army_62.54e67a82.jpg";